import { render, staticRenderFns } from "./StockActionsDialog.vue?vue&type=template&id=09bd6ce0&scoped=true"
import script from "./StockActionsDialog.vue?vue&type=script&lang=js"
export * from "./StockActionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bd6ce0",
  null
  
)

export default component.exports